const React = require('react');
const { Animated, View, Text, Image, ScrollView } = require('react-native');

const Reanimated = {
  ...Animated,
  View,
  Text,
  Image,
  ScrollView,
  createAnimatedComponent: (Comp) => Comp,
  useSharedValue: (init) => ({ value: init }),
  useAnimatedStyle: (cb) => cb() || {},
  useDerivedValue: (cb) => ({ value: cb() }),
  useAnimatedScrollHandler: () => () => {},
  useAnimatedGestureHandler: () => () => {},
  withTiming: (toValue) => toValue,
  withSpring: (toValue) => toValue,
  withDelay: (_delay, val) => val,
  withSequence: (...vals) => vals[vals.length - 1],
  withRepeat: (val) => val,
  runOnJS: (fn) => fn,
  runOnUI: (fn) => fn,
  Easing: {
    linear: (t) => t,
    ease: (t) => t,
    quad: (t) => t,
    cubic: (t) => t,
    in: (f) => f,
    out: (f) => f,
    inOut: (f) => f,
  },
};

module.exports = Reanimated;
module.exports.default = Reanimated;
